module.exports = __webpack_public_path__ + "static/media/North-Beacon-Woods.94e7635c.pdf";